import { ReactComponent as RefreshSvg } from "../../assets/images/svgs/icons8-refresh.svg";

const RefreshIcon = ({ className = "", ...props }) => {
  return (
    <RefreshSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default RefreshIcon;
